import { Navigate, useParams } from 'react-router-dom';
import { APP_LINKS } from '@/helpers/links';
import RefinancingPageV1 from './versions/v1';

const VERSIONS = ['v1'];

const RefinancingPage = () => {
  const { version } = useParams();

  if (version && !VERSIONS.includes(version)) {
    return <Navigate to={APP_LINKS.loanTermsRefinancing()} replace />;
  }

  switch (version) {
    case 'v1':
    default:
      return <RefinancingPageV1 />;
  }
};

export default RefinancingPage;
